import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchBookById } from "../../lib/booksApi";
import BookForm from "./BookForm";

export default function EditBookPage() {
  const { id } = useParams();
  const [state, setState] = useState({ status: "loading", book: null });

  useEffect(() => {
    fetchBookById(id).then(({ data }) => {
      setState({ status: data ? "ready" : "not-found", book: data });
    });
  }, [id]);

  if (state.status === "loading") return <p className="text-zinc-600">Loading…</p>;
  if (state.status === "not-found") {
    return <p className="text-zinc-600">Book not found.</p>;
  }

  return <BookForm mode="edit" book={state.book} />;
}
